import { useParams, Navigate } from "react-router-dom";

const BlogRedirect = () => {
    const { slug } = useParams();


    return <Navigate to={`/${slug}`} replace />;
};

export default BlogRedirect;